module["exports"] = [
  "SARL",
  "SA",
  "EURL",
  "SAS",
  "SEM",
  "SCOP",
  "GIE",
  "EI"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fr/company/suffix.js
// module id = 1679
// module chunks = 0